import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";

const UpdateGovtRateList = ({
  selectedRowsData,
  setSelectedRowsData,
  updateHandleChange,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [discom, setDiscom] = useState([]);
  const [discomId, setDiscomId] = useState([]);
  const [region, setRegion] = useState([]);
  const [regionId, setRegionId] = useState([]);
  const [storeProduct, setStoreProduct] = useState([]);
  const [productName, setProductName] = useState("");

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const [rowAddData, setRowAddData] = useState({
    circle_name: "",
    govt_rate: "",
  });
  const handleDiscomChange = (e) => {
    setDiscomId(e.target.value);
  };

  const handleRegionChange = (e) => {
    setRegionId(e.target.value);
  };

  function resetFields() {
    setDiscomId("");
    setRegionId("");
    setSelectedRowsData({
      circle_name: "",
      govt_rate: "",
      product_name:""
    });
  }

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { id, circle_name, govt_rate, product_name } = selectedRowsData;

    let BASE_URL = SERVER_URL + `/api/govt-rate/govt-rate-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        discom_id: discomId,
        region_id: regionId,
        circle_name,
        govt_rate,
        product_name
      }),
    });
    const response = await res.json();

    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        resetFields();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getDiscom = async () => {
    const BASE_URL = SERVER_URL + `/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setDiscom(result.data);
  };

  useEffect(() => {
    getDiscom();
  }, []);

  const getRegion = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/region/drop-region-list/${user_id}?discom_id=${discomId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setRegion(result.data);
  };

  useEffect(() => {
    if (discomId) {
      getRegion();
    }
  }, [discomId]);

  useEffect(() => {
    if (selectedRowsData) {
      setDiscomId(selectedRowsData.discom_id);
      setRegionId(selectedRowsData.region_id);
    }
  }, [selectedRowsData]);

  const getProductData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };

  useEffect(() => {
    getProductData();
  }, [productName]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Circle & Region
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="discom">Discom Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleDiscomChange}
                              value={discomId}
                              id="discom"
                              required
                            >
                              <option value="">Select Discom</option>
                              {discom &&
                                discom?.length > 0 &&
                                discom?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.discom_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="region">Region Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleRegionChange}
                              value={regionId}
                              id="region"
                              required
                            >
                              <option value="">Select Region</option>
                              {region &&
                                region?.length > 0 &&
                                region?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.region_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="circle_name">Circle Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="circle_name"
                              id="circle_name"
                              placeholder="Enter Circle Name"
                              value={selectedRowsData.circle_name}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Pole">Size</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="product_name"
                              id="Pole"
                              onChange={updateHandleChange}
                              value={selectedRowsData.product_name}
                              required
                            >
                              <option value="">Select Size</option>
                              {storeProduct &&
                                storeProduct.length > 0 &&
                                storeProduct?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.size}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="govt_rate">Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="govt_rate"
                              id="govt_rate"
                              placeholder="Enter Rate"
                              value={selectedRowsData.govt_rate}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateGovtRateList;
